var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.504,
    height: 21.505,
    viewBox: "0 0 21.504 21.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8245",
    "data-name": "Group 8245",
    transform: "translate(-4343.544 -1933.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8244",
    "data-name": "Group 8244",
    transform: "translate(4343.544 1933.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16846",
    "data-name": "Path 16846",
    d: "M4354.282,1955.268q-3.663,0-7.325,0a3.334,3.334,0,0,1-3.3-2.516,3.293,3.293,0,0,1-.109-.852q-.01-7.373,0-14.746a3.345,3.345,0,0,1,3.391-3.385q7.357-.007,14.713,0a3.344,3.344,0,0,1,3.393,3.383q.01,5.214,0,10.427a.866.866,0,0,1-.588.892.8.8,0,0,1-.927-.326,1.359,1.359,0,0,1-.149-.635q-.012-5.054-.006-10.108a1.75,1.75,0,0,0-1.974-1.965h-14.234a1.745,1.745,0,0,0-1.952,1.955q0,7.133,0,14.266a1.743,1.743,0,0,0,1.937,1.938h14.3a1.731,1.731,0,0,0,1.926-1.759.842.842,0,0,1,.858-.777.86.86,0,0,1,.811.868,3.328,3.328,0,0,1-2.281,3.149,4.189,4.189,0,0,1-1.191.183C4359.144,1955.276,4356.712,1955.268,4354.282,1955.268Z",
    transform: "translate(-4343.544 -1933.765)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16847",
    "data-name": "Path 16847",
    d: "M4403.846,1989.385a3.772,3.772,0,0,1,4.434-1.077,2.614,2.614,0,0,1,1.643,2.09,9.367,9.367,0,0,1,.192,1.71c.027,1.545.013,3.091.012,4.636a.863.863,0,0,1-.926.948c-.352.007-.7.007-1.055,0a.84.84,0,0,1-.911-.919c0-1.215.006-2.43-.005-3.645a7.852,7.852,0,0,0-.092-1.24c-.152-.894-.589-1.3-1.362-1.342a1.591,1.591,0,0,0-1.8,1.241,5.511,5.511,0,0,0-.144,1.231c-.019,1.215-.005,2.43-.008,3.645,0,.716-.316,1.028-1.035,1.03-.309,0-.618.007-.927,0a.839.839,0,0,1-.887-.911q0-3.837,0-7.673a.848.848,0,0,1,.911-.923c.3-.006.6,0,.9,0,.712,0,1.014.289,1.044.991C4403.829,1989.225,4403.836,1989.277,4403.846,1989.385Z",
    transform: "translate(-4392.401 -1979.919)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16848",
    "data-name": "Path 16848",
    d: "M4371.783,1993.851c0,1.257,0,2.514,0,3.771a.873.873,0,0,1-.984.982c-.341,0-.682.005-1.023,0a.861.861,0,0,1-.936-.937q-.005-3.818,0-7.637a.866.866,0,0,1,.938-.936c.362-.005.725-.006,1.086,0a.858.858,0,0,1,.917.922C4371.787,1991.295,4371.783,1992.573,4371.783,1993.851Z",
    transform: "translate(-4365.062 -1980.83)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16849",
    "data-name": "Path 16849",
    d: "M4367.54,1959.084a1.716,1.716,0,0,1,1.727-1.72,1.727,1.727,0,0,1-.016,3.453A1.71,1.71,0,0,1,4367.54,1959.084Z",
    transform: "translate(-4363.958 -1953.841)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.61f07fab79e9ec61cf4289f9f73fbd24.svg";
export { ForwardRef as ReactComponent };